import { Link } from '@tanstack/react-router';

import { appNavItems, getActiveNavItemId, type AppNavVariant } from './appNavModel.ts';

export interface AppNavProps {
  currentPath?: string;
  variant?: AppNavVariant;
}

export function AppNav({ currentPath = '', variant = 'top' }: AppNavProps): React.ReactElement {
  const activeId = getActiveNavItemId(currentPath);
  const isMobileBottom = variant === 'mobile-bottom';
  const items =
    variant === 'mobile-bottom'
      ? appNavItems
      : appNavItems.filter((item) => item.id !== 'new-invoice');

  return (
    <nav
      aria-label={isMobileBottom ? 'Mobile app navigation' : 'App navigation'}
      className={
        isMobileBottom
          ? 'fixed inset-x-0 bottom-0 z-40 border-t border-line bg-paper-soft/95 px-2 pb-[env(safe-area-inset-bottom)] shadow-[0_-12px_28px_-18px_rgba(31,27,21,0.25)] backdrop-blur sm:hidden'
          : 'bg-transparent'
      }
    >
      <div
        className={
          isMobileBottom
            ? 'mx-auto grid max-w-md grid-cols-4 gap-1 py-2'
            : 'flex gap-1 overflow-x-auto'
        }
      >
        {items.map((item) => {
          const active = activeId === item.id;
          return (
            <Link
              key={item.href}
              to={item.href as never}
              aria-current={active ? 'page' : undefined}
              data-nav-item={item.id}
              className={classNames(
                'inline-flex shrink-0 items-center justify-center rounded-full text-sm font-medium transition',
                isMobileBottom ? 'min-h-11 min-w-0 px-1 text-center leading-tight' : 'h-10 px-4',
                active
                  ? 'bg-ink text-paper-soft shadow-[0_8px_18px_-12px_rgba(31,27,21,0.55)]'
                  : 'text-ink-soft hover:bg-paper-deep hover:text-ink',
              )}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

function classNames(...values: Array<string | false | undefined>): string {
  return values.filter(Boolean).join(' ');
}
